import React from 'react';
import { Dropdown } from 'semantic-ui-react';

const NavigationDropDownOptions = ({ tabs }) => tabs.map((tab) => (
  <Dropdown.Item
    key={`tab_${tab.url}`}
    icon={tab.dropDownIcon}
    text={tab.name}
    value={tab.url}
    active={tab.selected}
    as="a"
    href={`/#${tab.url}`}
  />
));

export default NavigationDropDownOptions;
